export default function appendTypeToSources(sources) {
  return sources.map(({ src, type, label }) => {
    let actualType;
    const sourcePathname = new URL(src).pathname;
    if (sourcePathname.match(/\.mp4$/) || type === 'mp4') {
      actualType = 'video/mp4';
    } else if (sourcePathname.match(/\.m3u8$/)) {
      actualType = 'application/x-mpegURL';
    } else {
      throw new Error('unsupported video type');
    }

    return {
      src,
      label,
      type : actualType
    };
  });
}
